import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { SuccessMessage, ErrorMessage } from '../../../../extras/toastMessages';
import clienteAxios from '../../../../../config/axios';
import { MSG_REJECT_SUCCESS } from '../../../../../constants/messages';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner'
//Redux
import { useDispatch } from 'react-redux';
import { updateProceedingAction } from '../../../../../actions/audiencesActions';
//Función principal
const ProceedingForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Genero los ref
    const refProceeding = useRef();
    //Inicializo datos
    const initialData = {
        expediente: audience && audience.expediente ? audience.expediente.numero : '',
        fechaHecho: audience && audience.expediente ? audience.expediente.fechaHecho : '',
        caratula: audience && audience.expediente ? audience.expediente.caratula : '',
    }
    //Inicializo dispatch
    const dispatch = useDispatch();
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refProceeding.current.focus();
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo los datos
        let data = {
            ...audience.expediente,
            numero: values.expediente,
            fechaHecho: values.fechaHecho,
            caratula: values.caratula
        }
        //Elimino el ID
        delete data.id;
        //Llamo al dispatch
        dispatch( updateProceedingAction(audience, data, handleClose) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        expediente: yup.string().required(),
        fechaHecho: yup.date().required(),
        caratula: yup.string().required()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Expediente <small><strong>(Audiencia #{ audience && audience.id })</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Indique el número de expediente
                                    </div>
                                </div>
                                <Form.Group className="col-md-4 col-12">
                                    <Form.Control
                                        id="expediente"
                                        className="form-control" 
                                        autoFocus 
                                        name="expediente" 
                                        type="text" 
                                        placeholder="No. Expediente"
                                        value={ values.expediente }
                                        onChange={handleChange}
                                        isInvalid={!!errors.expediente}
                                        disabled={ loading }
                                        ref={refProceeding}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.expediente }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4 col-12">
                                    <Form.Control
                                        id="fechaHecho"
                                        className="form-control" 
                                        autoFocus 
                                        name="fechaHecho" 
                                        type="date" 
                                        placeholder="Fecha hecho"
                                        value={ values.fechaHecho }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fechaHecho}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fechaHecho }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="caratula"
                                        className="form-control" 
                                        autoFocus 
                                        name="caratula" 
                                        type="text" 
                                        placeholder="Carátula"
                                        value={ values.caratula }
                                        onChange={handleChange}
                                        isInvalid={!!errors.caratula}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.caratula }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ProceedingForm;